import type { ControllerProps, FieldPath, FieldValues } from 'react-hook-form'
import {
	FormControl,
	FormField,
	FormItem,
	FormLabel,
	FormMessage,
} from '@cocoonspace/ui/components/form'

interface FormControlledInputProps {
	label?: string | React.ReactNode
	required?: boolean
	classNames?: {
		formItem?: string
		formLabel?: string
		formControl?: string
		formMessage?: string
	}
}

export const FormControlledInput = <
	TFieldValues extends FieldValues = FieldValues,
	TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
>({
	label,
	required,
	render,
	classNames,
	...props
}: ControllerProps<TFieldValues, TName> & FormControlledInputProps) => (
	<FormField
		{...props}
		render={(renderProps) => (
			<FormItem className={classNames?.formItem}>
				{!!label && (
					<FormLabel className={classNames?.formLabel}>
						{label}
						{!!required && <sup>*</sup>}
					</FormLabel>
				)}

				<FormControl className={classNames?.formControl}>
					{render(renderProps)}
				</FormControl>

				<FormMessage className={classNames?.formMessage} />
			</FormItem>
		)}
	/>
)
